import React from "react";
import cn from "classnames";
import License from "../License/License";

class MoreInformation extends React.Component {
  constructor(props) {
    super(props);

    this.toggleComponent = this.toggleComponent.bind(this);

    this.state = {
      componentOpen: false,
    };
  }

  toggleComponent = (e) => {
    e.preventDefault();
    const open = e.target.classList.contains("open");

    this.setState({
      componentOpen: open ? false : true,
    });
  };

  render() {
    return (
      <div className="gallery-carousel-bottom">
        <div className="big-toggler-trigger">
          <button
            type="button"
            onClick={this.toggleComponent}
            className={
              "reset icon-right " +
              (this.state.componentOpen
                ? " icon-zoom-out open"
                : " icon-zoom-in")
            }
          >
            {this.props.cmsData.readMoreAboutItemText}
          </button>
        </div>

        <div
          className={cn("gallery-carousel-extra", {
            closed: !this.state.componentOpen,
            "no-content": !this.props.info.otherInformation,
          })}
          onClick={
            !this.state.componentOpen ? this.toggleComponent : () => ({})
          }
        >
          {this.props.info.otherInformation && (
            <div className="gallery-carousel-extra-fade" />
          )}
          <div className="gallery-carousel-info-text">
            {this.props.info.otherInformation && (
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.info.otherInformation.replace(
                    /(?:\r\n|\r|\\r\\n)/g,
                    "<br />"
                  ),
                }}
              />
            )}
          </div>
          <div
            className={
              "gallery-carousel-info-photo " +
              (this.props.info.otherInformation ? "has-text" : "")
            }
          >
            <License
              info={this.props.info}
              multipleActiveSlide={this.props.multipleActiveSlide}
              cmsData={this.props.cmsData}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MoreInformation;
